import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'

import { triggersClient } from '../../../../../../utils/apollo/api'
import { useTableActions } from '../../../../../../components/tables/MultiSelectTableContext'

const MUTATION = gql`
  mutation RetryTriggerCall($id: Int) {
    retryTriggerCall(id: $id) {
      id
    }
  }
`

export const useRetryTriggerCall = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['TriggerCalls', 'TriggerCallsCount'],
    client: triggersClient
  })
  const notify = useNotification()
  const alert = useAlert()
  const { clearSelection } = useTableActions()

  const handleRequest = id => {
    if (!alert.confirm({ title: 'Tem certeza que deseja executar novamente?' })) return false

    return request({ variables: { id } }).then(resp => {
      if (!resp.errors) {
        if (clearSelection) clearSelection()
      } else {
        notify.error({ title: 'Ocorreu um erro!' })
      }
    })
  }

  return [handleRequest, state]
}
